module.exports = __webpack_public_path__ + "static/media/reachedTournamentTop10_10_15.bc7f16ca.png";